import { useReducer } from 'react'
import { Link, useHistory } from 'react-router-dom'
import swal from 'sweetalert'
import imgLogo from '../../assets/img/logo.svg'
import { Button } from '../../components/button'
import { Main } from './style'
import { Usuario } from '../../model/Usuario'
import Action from '../../model/Action'
import UsuarioService from '../../services/UsuarioService'

function reducer(userPayload: Usuario, action: Action): Usuario {
    switch (action.type) {
    case 'setFirstName':
        return {
            ...userPayload,
            firstName: action.payload
        }
    case 'setLastName':
        return { ...userPayload, lastName: action.payload }
    case 'setEmail':
        return { ...userPayload, email: action.payload }
    case 'setPassword':
        return { ...userPayload, password: action.payload }
    default:
        return userPayload
    }
}

const initialUser: Usuario = {
    firstName: '',
    lastName: '',
    email: '',
    password: ''
}

const CadastrarUsuario = () => {
    const [userPayload, exec] = useReducer(reducer, initialUser)
    const history = useHistory()

    const handleSubmit = (event: any) => {
        event.preventDefault()
        UsuarioService.save(userPayload).then(() => {
            swal({
                title: 'Cadastro realizado com Sucesso!',
                icon: 'success',
                buttons: [false],
                timer: 2000
            })

            setTimeout(() => {
                history.push('/login')
            }, 3000)
        }).catch(() => {
            swal({
                title: 'Ocorreu um erro ao cadastrar!',
                icon: 'error',
                buttons: [false],
                timer: 2000
            })
        })
    }

    function onChangeInput(type: string, payload: string) {
        exec({ type, payload })
    }

    return (
        <Main>
            <form className="cadastro" onSubmit={handleSubmit}>
                <img
                    src={imgLogo}
                    width="238"
                    height="45"
                    alt="Logo da Conectaê."
                />
                <div className="form-row w-100">
                    <div className="col-md-6 mb-3">
                        <label htmlFor="idNome">
                            Nome:
                            <input
                                type="text"
                                className="form-control"
                                id="idNome"
                                autoComplete="off"
                                onChange={(event) => {
                                    return onChangeInput(
                                        'setFirstName', event.target.value
                                    )
                                }}
                                required
                            />
                        </label>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label htmlFor="idSobrenome">
                            Sobrenome:
                            <input
                                type="text"
                                className="form-control"
                                id="idSobrenome"
                                autoComplete="off"
                                onChange={(event) => {
                                    return onChangeInput(
                                        'setLastName', event.target.value
                                    )
                                }}
                                required
                            />
                        </label>
                    </div>
                </div>
                <div className="form-row w-100">
                    <div className="col-md-6 mb-3">
                        <label htmlFor="idEmail">
                            E-mail:
                            <input
                                type="text"
                                className="form-control"
                                id="idEmail"
                                autoComplete="off"
                                onChange={(event) => {
                                    return onChangeInput(
                                        'setEmail', event.target.value
                                    )
                                }}
                                required
                                pattern="^[^@]+@[^@]+\.[^@]+$"
                            />
                        </label>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label htmlFor="idSenha">
                            Senha:
                            <input
                                type="password"
                                className="form-control"
                                id="idSenha"
                                autoComplete="off"
                                onChange={(event) => {
                                    return onChangeInput(
                                        'setPassword', event.target.value
                                    )
                                }}
                                required
                            />
                        </label>
                    </div>
                </div>
                <Button type="submit">
                    Cadastrar
                </Button>
                <p>
                    <span>Já tem conta? </span>
                    <Link to="/login">Entre agora!</Link>
                </p>
            </form>
        </Main>
    )
}
export default CadastrarUsuario
